export default __webpack_public_path__ + "static/media/IMG_9892.1bc7aefe.jpg";